import { TextInput as TextInputMantine } from "@mantine/core";
import classNames from "classnames";
import { useEffect, useState } from "react";
import { TextInputProps } from "./definitions";

export const TextInput = ({
  placeholder,
  label,
  error,
  size,
  disabled,
  required,
  type = "text",
  onChange,
  value,
  pattern,
  key,
  form,
  maxLength,
  ref,
  readOnly,
  icon,
}: TextInputProps) => {
  const [disabledStyle, setDisabledStyle] = useState("");

  useEffect(() => {
    setDisabledStyle(classNames({ "hover:cursor-not-allowed": disabled }));
  }, []);

  return (
    <TextInputMantine
      key={key}
      ref={ref}
      // classNames={{
      //   input: `rounded-lg p-1 px-2 shadow border-1 border-[#666666] focus:border-2 focus:border-primary ${disabledStyle}`,
      // }}
      classNames={{
        input: `rounded-lg ${
          icon ? "" : "p-1 px-2"
        } shadow border-1 border-[#666666] focus:border-2 focus:border-primary ${disabledStyle}`,
      }}
      icon={icon}
      pattern={pattern}
      type={type}
      form={form}
      placeholder={placeholder}
      maxLength={maxLength}
      label={label}
      error={error}
      size={size}
      disabled={disabled}
      required={required}
      onChange={onChange}
      value={value}
      readOnly={readOnly}
    />
  );
};
